import { createSlice } from "@reduxjs/toolkit";

export const HomeSlice = createSlice({
  name: "home",
  initialState: {
    init: false,
    data: [],
  },
  reducers: {
    setData: (state, action) => {
      state.data = action.payload;
      state.init = true;
    },
    removeWidget: (state, action) => {
      state.data = state.data.filter((widget) => widget.id !== action.payload);
    },
  },
});

export const { setData, removeWidget } = HomeSlice.actions;

export default HomeSlice.reducer;
